export default __webpack_public_path__ + "static/media/closeIcon.621e09f3.png";